import { FormattingRule } from '../types';
import { APIEntityType } from '@ardoq/api-types';
import { FormattingRuleRowByTag } from './FormattingRuleRowByTag';
import { FormattingRuleRowByComponentOrReference } from './FormattingRuleRowByComponentOrReference';
import { NewFormattingRuleRowByComponentOrReference } from './NewFormattingRuleRowByComponentOrReference';
import { NewFormattingRuleRowByTag } from './NewFormattingRuleRowByTag';

type EntityFormattingRuleProperties = {
  formattingRule: FormattingRule;
  isNewConditionalFormatting: boolean;
  dragAndDropCardId: string; // this property might appear unused. it is used. it's magic.
};
export const EntityFormattingRule = ({
  formattingRule,
  isNewConditionalFormatting,
}: EntityFormattingRuleProperties) => {
  if (formattingRule.type === APIEntityType.TAG) {
    return isNewConditionalFormatting ? (
      <NewFormattingRuleRowByTag formattingRule={formattingRule} />
    ) : (
      <FormattingRuleRowByTag formattingRule={formattingRule} />
    );
  }

  if (isNewConditionalFormatting) {
    return (
      <NewFormattingRuleRowByComponentOrReference
        formattingRule={formattingRule}
      />
    );
  }

  return (
    <FormattingRuleRowByComponentOrReference formattingRule={formattingRule} />
  );
};
